import { apiv2Url } from './config';
import { getPromise, postPromise } from './utils';

const resetSeminarRead = (): Promise<void> =>
  postPromise(`${apiv2Url}/reset-seminar-read/admin`, {});

const getSeminarRead = (): Promise<boolean> =>
  getPromise(`${apiv2Url}/read_seminar`, {});

const readSeminar = (): Promise<void> =>
  postPromise(`${apiv2Url}/read_seminar`, {});

export default {
  resetSeminarRead,
  getSeminarRead,
  readSeminar,
};
